import React, { useState, useEffect, useCallback, useRef } from 'react';
import sanitizeHtml from "sanitize-html"
import ContentEditable from 'react-contenteditable';
import './JobAdDisplay.css';

function JobAdDisplay({ text, html, notifyTextChanged }) {

  const htmlMode = true;

  const [htmlContent, setHtmlContent] = useState('');
  const contentEditableRef = useRef(null);

  const processContentChange = useCallback((html) => {

    const sanitizeConfText = {
      allowedTags: ['br', 'div'],
      allowedAttributes: {}
    };
    let textOnly = sanitizeHtml(html, sanitizeConfText);
    textOnly = textOnly.replace(new RegExp(`(<br />)`, "g"), '')
    textOnly = textOnly.replace(new RegExp(`(<div>)`, "g"), '')
    textOnly = textOnly.replace(new RegExp(`(</div>)`, "g"), '\n')

    // remove last linebreak
    if (textOnly.endsWith('\n'))
      textOnly = textOnly.substring(0, textOnly.length - 1);

    if (notifyTextChanged) {
      notifyTextChanged({
        text: textOnly,
        html
      });
    }
  }, [notifyTextChanged]);
  
  useEffect(() => {
    setHtmlContent(html);
    processContentChange(html);
  }, [html, processContentChange]);

  const handleContentChange = useCallback((evt) => {

    const html = evt.currentTarget.innerHTML;

    // Update the component
    setHtmlContent(html);

    // Process content change
    processContentChange(html);
  }, [processContentChange]);

  return (
    <>

      {/* Generated text */}
      {!htmlMode &&
        <textarea
          spellCheck="false"
          className="Generate-result"
          value={text}
          readOnly
          rows="10"
        />
      }

      {/* Generated html */}
      {htmlMode &&
        <>

          <div className='jobad-display-container'>
            <ContentEditable
              innerRef={contentEditableRef}
              className='jobad-display-div'
              html={htmlContent} // innerHTML of the editable div
              disabled={false} // use true to disable edition
              onChange={handleContentChange} // handle innerHTML change
            />
          </div>
        </>
      }

    </>
  )

}

export default JobAdDisplay;